/**
 * @file
 * @auth jinguangguo
 * @date 2016/11/1
 */

import ajax from '../util/ajax';

const RENDER_INTERVAL = 10000;

export default {

    /**
     * 搜索类型查询
     * @param param
     * @returns {*}
     */
    queryType(param = {}) {
        return ajax.send('Query.Type',param);
    },

    /**
     * 轮训统计数据
     */
    onLoopStatistic: (function () {
        const LOOP_TIME = RENDER_INTERVAL;
        let isRequesting = false;

        let callbacks = [];

        return function (callback) {
            let that = this;

            callbacks.push(callback);

            if (isRequesting === true) {
                return;
            } else {
                loop();
            }

            // 非调试状态下
            var timer = setInterval(() => {
                if(location.hash.indexOf('?')>0){
                    clearInterval(timer);
                    return;
                }else{
                    loop();
                }
            }, LOOP_TIME);

            function loop() {
                isRequesting = true;
                that.loopStatistic().then((rep) => {
                    isRequesting = false;
                    callbacks.forEach((callback, index) => {
                        callback.call(that, rep);
                    });
                });
            }
        };
    })(),

    /**
     * 主页统计数据
     * @param param
     * @returns {*}
     */
    loopStatistic(param = {}) {
        return ajax.send('Statistic.Transaction', param);
    },

    /**
     * 轮训区块列表
     */
    onLoopBlockList: (function () {
        const LOOP_TIME = RENDER_INTERVAL;
        let isRequesting = false;

        let callbacks = [];

        return function (callback) {
            let that = this;

            callbacks.push(callback);

            if (isRequesting === true) {
                return;
            } else {
                loop();
            }

            // 非调试状态下
            var timer = setInterval(() => {
                if(location.hash.indexOf('?')>0){
                    clearInterval(timer);
                }else{
                    loop();
                }
            }, LOOP_TIME);

            function loop() {
                isRequesting = true;
                that.LoopBlockList().then((rep) => {
                    isRequesting = false;
                    callbacks.forEach((callback, index) => {
                        callback.call(that, rep);
                    });
                });
            }
        };
    })(),

    /**
     * 轮训查询区块列表
     * @param param
     * @returns {*}
     */
    LoopBlockList(param = {}) {
        return ajax.send('Block.Query', param);
    },

    onLoopDealList: (function () {
        const LOOP_TIME = RENDER_INTERVAL;
        let isRequesting = false;

        let callbacks = [];

        return function (callback) {
            let that = this;

            callbacks.push(callback);

            if (isRequesting === true) {
                return;
            } else {
                loop();
            }

            // 非调试状态下
            var timer = setInterval(() => {
                if(location.hash.indexOf('?')>0){
                    clearInterval(timer);
                }else{
                    loop();
                }
            }, LOOP_TIME);

            function loop() {
                isRequesting = true;
                that.LoopDealList().then((rep) => {
                    isRequesting = false;
                    callbacks.forEach((callback, index) => {
                        callback.call(that, rep);
                    });
                });
            }
        };
    })(),

    /**
     * 轮训查询交易列表
     * @param param
     * @returns {*}
     */
    LoopDealList(param = {}) {
        return ajax.send('Transaction.Query', param);
    },

    /**
     * 获取区块信息
     * @param param
     * @returns {*}
     * */
    blockInfo(param = {}) {
        return ajax.send('Block.Query',param);
    },


    /**
     * 获取交易信息
     * @param param
     * @returns {*}
     * */
    tradeInfo(param = {}) {
        return ajax.send('Transaction.Query', param);
    },

    /**
     * 搜索合约详细信息
     * @param param
     * @returns {*}
     * */
    contractInfo(param = {}){
        return ajax.send('ContractInfo.Query', param);
    },
    /**
     * 搜索合约出账详细信息
     * @param param
     * @returns {*}
     * */
    transactionExInfo(param = {}){
        return ajax.send('TransactionEx.Query', param);
    },

};


// WEBPACK FOOTER //
// ./src/common/commonService.js